import { capitalizeFirstLetter } from 'utils/helpers';
import { DESCENDING } from 'constants/sortDirections';

export const CHECKBOX_SIZE = 40;
export const ROW_PADDING = 36;

/**
 * getCellWidth
 * Gets the style object for the width of a table cell.
 * @param { Number } width: The width of the cell. If passed in, minWidth and MaxWidth will be used.
 * @param { Number } minWidth: The min width of the cell if width is not passed in.
 * @param { Number } maxWidth: The max width of the cell if width is not passed in.
 * @returns { Object } The style object containing min and max widths.
 */
export const getCellWidth = (width, minWidth, maxWidth) => ({
  minWidth: width || minWidth,
  maxWidth: width || maxWidth,
});

/*------------------------------------------------------------------------------------------------*/
/* Table Query Param Helpers                                                                      */
/*------------------------------------------------------------------------------------------------*/
export const defaultQueryParams = {
  page: 1,
  pageSize: 10,
  orderBy: 'id',
  sorting: DESCENDING,
  filter: '',
};

export const formatSortAndOrder = ({ sorting, orderBy, ...otherParams }) => ({
  ...otherParams,
  sortDesc: sorting === DESCENDING,
  orderBy: `By${capitalizeFirstLetter(orderBy)}`,
});
